import { Component } from "react";
import TalaeraRoutes from "./../../../../../routes/TalaeraRoutes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import useUser from "hooks/useUser";

export default function MyExercisesSection(props) {
  const user = useUser();

  if (!user.instructor) {
    return null;
  }

  return (
    <Translation>
      {t => (
        <SidePanelSection
          sectionTitle={t("Common.My Exercises")}
          list={[
            {
              id: user.instructor.id,
              name: t("Common.createdByMe"),
            },
          ]}
          location={props.location}
          tagName={MyExercisesListItem}
        />
      )}
    </Translation>
  );
}

class MyExercisesListItem extends Component {
  render() {
    const path = TalaeraRoutes.buildMyExerciseListPath(this.props.item.id);
    const isActive = TalaeraRoutes.isMyExerciseListPath(this.props.location);
    return (
      <li className={isActive ? "active" : ""}>
        <Link className="btn" to={path}>
          {this.props.item.name}
        </Link>
      </li>
    );
  }
}
